import { FeatureSectionFormErrorJSON } from '../models/feature-section';

export const formFeatureSectionErrors: FeatureSectionFormErrorJSON = {
    footerLogoWidth: [
        {
            code: 'required',
            message: 'This field is required',
        },
    ],
    footerLogoHeight: [
        {
            code: 'required',
            message: 'This field is required',
        },
    ],
};
